import { render, staticRenderFns } from "./ProjectsTabs.vue?vue&type=template&id=0f57d814&scoped=true"
import script from "./ProjectsTabs.vue?vue&type=script&lang=js"
export * from "./ProjectsTabs.vue?vue&type=script&lang=js"
import style0 from "./ProjectsTabs.vue?vue&type=style&index=0&id=0f57d814&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f57d814",
  null
  
)

export default component.exports